import { Button } from 'antd';
import { Icon } from './icons';
import type { Product } from './products';

type Props = {
    product: Product;
    onOpen?: (p: Product) => void;
};

export function ProductCard({ product, onOpen }: Props) {
    const IconC = Icon[product.icon] ?? Icon.car;

    const handleOpen = () => {
        if (onOpen) onOpen(product);
        else if (product.href) window.location.href = product.href;
    };

    return (
        <div className={'pcard' + (product.isNew ? ' is-new' : '')}>
            {product.isNew && <span className="badge-new">Новый</span>}

            <div className="pcard-top">
                <div>
                    <h3 className="pcard-title">{product.title}</h3>
                    <p className="pcard-sub">{product.sub}</p>
                </div>
                <div className="pcard-icon">
                    <IconC />
                </div>
            </div>

            <div className="pcard-reward">
                <div className="value">{product.reward}</div>
                <div className="label">Вознаграждение</div>
            </div>

            <div className="pcard-actions">
                <Button type="primary" size="middle" onClick={handleOpen}>
                    Оформить
                </Button>
                {product.wiki && (
                    <Button
                        type="link"
                        href={product.wiki}
                        target="_blank"
                        rel="noopener"
                        style={{ padding: 0 }}
                    >
                        Подробнее →
                    </Button>
                )}
            </div>
        </div>
    );
}
